import React from "react";
import { Link } from 'react-router-dom';

export default function PlusLoinMariage(args) {

    return (
        <>
            <blockquote className="blog-quote">
                <b>Pour aller plus loin sur  la convention de PACS chez le notaire :</b><br />
                <Link to="/pacs/notaire/avantages-juridiques-de-votre-convention-de-pacs-chez-le-notaire" >Les avantages juridiques de votre convention de pacs chez le notaire</Link><br />
                <Link to="/pacs/notaire/tout-savoir-sur-la-convention-de-pacs-chez-le-notaire">Tout savoir sur la convention de PACS chez le notaire</Link><br />
                <Link to="/pacs/notaire/etapes-pacs-notaire">Les étapes de votre convention de PACS chez le notaire</Link><br/>
                <Link to="/pacs/notaire/details-clauses-convention-de-pacs-chez-le-notaire">Que peut-on prévoir dans une convention de PACS notariée ?</Link>
            </blockquote>
        </>
    );
}
